module.exports = __webpack_public_path__ + "static/media/carmella.1df1fc45.svg";